import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';

import 'dayjs/locale/ja';
import dayjs from 'dayjs';
dayjs.locale('ja');
Vue.prototype.$dayjs = dayjs;

import '../../_modules/bootstrap';

import vuetify from '../_plugins/vuetify';

// root component
import App from './App.vue';

const createApp = async () => {
  new Vue({
    el: '#app',
    vuetify,
    components: {
      App,
    },
    template: '<App />',
  });
};

createApp();

// おすすめ商品のスライダー
import Swiper, { Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Pagination]);

const swiper = new Swiper('.slide-items__container', {
  slidesPerView: 3,
  slidesPerGroup: 3,
  spaceBetween: 20,
  loop: true,
  loopFillGroupWithBlank: true,
  pagination: {
    el: '.slide-items__pagination',
    clickable: true,
  },
  breakpoints: {
    769: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      spaceBetween: 30,
    },
  },
});
